import { Action } from 'redux'
import { ThunkAction } from 'redux-thunk'
import { RootState } from '../index'
import { SkusTypes } from './types'
import { createSkuService } from '../../api/skus'

export const fetchSkus = (
  offerTypeId: number
): ThunkAction<void, RootState, unknown, Action<string>> => {
  const skusService = createSkuService()

  return async dispatch => {
    const response = await skusService.getSkusByOfferTypeId(offerTypeId)

    dispatch({
      type: SkusTypes.SAVE_SKUS,
      payload: response
    })
  }
}
